import { useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { initials } from '../../utils/helpers';

export default function TopNav({ onSearch }) {
  const { user, logout, isAdmin } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [searchTerm, setSearchTerm] = useState('');

  function handleSearch(e) {
    e.preventDefault();
    if (searchTerm.trim()) {
      navigate(`/search?q=${encodeURIComponent(searchTerm.trim())}`);
      setSearchTerm('');
    }
  }

  function isActive(path) {
    return location.pathname.startsWith(path) ? 'nav-link active' : 'nav-link';
  }

  return (
    <nav style={{
      background: '#fff',
      borderBottom: '1px solid #e0e4ec',
      padding: '0 2rem',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      height: 56,
      position: 'sticky',
      top: 0,
      zIndex: 100,
      boxShadow: '0 1px 4px rgba(0,0,0,0.05)',
    }}>
      {/* Logo */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 16, fontWeight: 600, color: '#1a1a2e' }}>
        <div style={{ width: 34, height: 34, background: '#185FA5', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" stroke="#fff" strokeWidth="1.8" fill="none"/>
            <polyline points="9 22 9 12 15 12 15 22" stroke="#fff" strokeWidth="1.8"/>
          </svg>
        </div>
        LoanDesk
      </div>

      {/* Nav links */}
      <div style={{ display: 'flex', gap: 4 }}>
        <NavLink to="/queue" label="Queue" isActive={isActive('/queue')} />
        <NavLink to="/my-files" label="My files" isActive={isActive('/my-files')} />
        {isAdmin && <NavLink to="/financials" label="Financials" isActive={isActive('/financials')} />}
        {isAdmin && <NavLink to="/productivity" label="Productivity" isActive={isActive('/productivity')} />}
        {isAdmin && <NavLink to="/call-report" label="Call report" isActive={isActive('/call-report')} />}
        {isAdmin && <NavLink to="/admin" label="Admin" isActive={isActive('/admin')} />}
      </div>

      {/* Right side */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        {/* Search */}
        <form onSubmit={handleSearch} style={{ display: 'flex', alignItems: 'center', border: '1px solid #d0d5e0', borderRadius: 7, background: '#f4f6f9', overflow: 'hidden', transition: 'border-color 0.15s' }}>
          <input
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
            placeholder="Search files..."
            style={{ border: 'none', background: 'transparent', padding: '7px 12px', fontSize: 13, outline: 'none', width: 220 }}
          />
          <button type="submit" style={{ background: 'none', border: 'none', borderLeft: '1px solid #e0e4ec', padding: '7px 12px', cursor: 'pointer', color: '#888', display: 'flex', alignItems: 'center' }}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
            </svg>
          </button>
        </form>

        {/* New file */}
        <Link to="/orders/new" className="btn btn-primary btn-sm">+ New file</Link>

        {/* User chip */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '5px 12px', borderRadius: 20, background: '#f4f6f9', fontSize: 13, color: '#444' }}>
          <div style={{ width: 28, height: 28, borderRadius: '50%', background: '#185FA5', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 600, flexShrink: 0 }}>
            {initials(user?.fullName || '')}
          </div>
          <span>{user?.fullName}</span>
        </div>

        <button className="btn btn-sm" onClick={logout}>Sign out</button>
      </div>
    </nav>
  );
}

function NavLink({ to, label, isActive }) {
  return (
    <Link
      to={to}
      style={{
        padding: '6px 14px',
        borderRadius: 7,
        textDecoration: 'none',
        fontSize: 13,
        fontWeight: 500,
        color: isActive === 'nav-link active' ? '#185FA5' : '#666',
        background: isActive === 'nav-link active' ? '#e8f0fb' : 'none',
        transition: 'all 0.15s',
      }}
    >
      {label}
    </Link>
  );
}
